import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { Container, Header, HeaderLeft, Title, Content, BackButton } from '../../../common/styles';
import { MainContainer } from '../styles';
import { TabContainer, TabButton } from './styles';
import SkillsSelection from './components/SkillsSelection';
import GradesThreshold from './components/GradesThreshold';
import { skillsApi } from '../../../../services/api';
import { useAlert } from '../../../../contexts/AlertContext';
import LoadingSpinner from '../../../common/LoadingSpinner';
import { getTemplateTypeText, MATRIX_TEMPLATE_TYPES } from '../../../../constants/matrixTemplateTypes';
const TABS = {
  SKILLS_SELECTION: 'SKILLS_SELECTION',
  GRADES_THRESHOLD: 'GRADES_THRESHOLD'
};

const SkillsMatrixVersionConfigure = () => {
  const { matrixId, versionId } = useParams();
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const [activeTab, setActiveTab] = useState(TABS.SKILLS_SELECTION);
  const [version, setVersion] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        const data = await skillsApi.getTemplateById(versionId);
        setVersion(data);
      } catch (error) {
        showAlert('Failed to fetch version details', 'error', error);
        navigate(`/skills-matrix/templates/${matrixId}/versions`);
      } finally {
        setLoading(false);
      }
    };

    fetchVersion();
  }, [versionId, matrixId, navigate, showAlert]);

  const renderContent = () => {
    switch (activeTab) {
      case TABS.SKILLS_SELECTION:
        return <SkillsSelection 
          isTechnicalAssessment={version?.type === MATRIX_TEMPLATE_TYPES.TECHNICAL_ASSESSMENT}
        />;
      case TABS.GRADES_THRESHOLD:
        return <GradesThreshold 
          isTechnicalAssessment={version?.type === MATRIX_TEMPLATE_TYPES.TECHNICAL_ASSESSMENT} 
        />;
      default:
        return null;
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <Container>
      <Header>
        <HeaderLeft>
          <BackButton onClick={() => navigate(`/skills-matrix/templates/${matrixId}/versions`)}>
            <FaArrowLeft /> Back to Versions
          </BackButton>
          <Title>Configure | {version?.skillsMatrix?.name} | {getTemplateTypeText(version?.type)} | v.{version?.version}</Title>
        </HeaderLeft>
      </Header>

      <Content>
        <TabContainer>
          <TabButton
            data-active={activeTab === TABS.SKILLS_SELECTION}
            onClick={() => setActiveTab(TABS.SKILLS_SELECTION)}
          >
            Skills Selection
          </TabButton>
          <TabButton
            data-active={activeTab === TABS.GRADES_THRESHOLD}
            onClick={() => setActiveTab(TABS.GRADES_THRESHOLD)}
          >
            Grades Threshold
          </TabButton>
        </TabContainer>

        <MainContainer>
          {renderContent()}
        </MainContainer>
      </Content>
    </Container>
  );
};

export default SkillsMatrixVersionConfigure; 